import { motion } from 'framer-motion';
import ReactPlayer from 'react-player';
import InfoCardCompo from '../components/infoCard/infocard-component';
import { Image, createStyles, Button, Container, Center } from '@mantine/core';
import { Carousel } from '@mantine/carousel';
import JumboTron2 from '../components/jumbotron-2/jumbotron2-component';
import ArticleMobileCompo from '../components/content/articlemobile-component';
import { useEffect, useState } from 'react';
import VideoCompo from '../components/content/video-component';
import CardArticleCompo from '../components/content/cardarticle-component';
import { FooterCompo } from '../components';
import TitleComponent from '../components/Admin/title-component';
import DescriptionAdminComponent from '../components/Admin/descriptionadmin-component';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ErrorPage from './Error';
import { videosStore } from '../store/reducers/videoSlice';
import { articlesStore } from '../store/reducers/articleSlice';

const useStyle = createStyles((theme) => ({
  image: {
    '@media (max-width: 600px)': {
      marginTop: 30,
      width: 300,
    },
  },
  title: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: 48,
    color: '#000000',
    fontWeight: 700,
    marginTop: 40,
    marginBottom: 10,
    '@media (max-width: 600px)': {
      fontSize: 20,
    },
  },
  textDetail: {
    fontSize: 24,
    fontWeight: 700,
    color: '#1C7849',
    '@media (max-width: 600px)': {
      fontSize: 16,
    },
  },
  textDetail2: {
    marginLeft: 40,
    fontSize: 24,
    fontWeight: 400,
    '@media (max-width: 600px)': {
      fontSize: 16,
    },
  },
  textDetail3: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontWeight: 700,
    fontSize: 24,
    color: '#4D4D4D',
    marginBottom: 40,
    '@media (max-width: 600px)': {
      display: 'none',
    },
  },
  textDetail4: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontWeight: 700,
    fontSize: 24,
    color: '#4D4D4D',
    marginTop: 40,
    marginBottom: 40,
    '@media (max-width: 600px)': {
      fontFamily: 'Poppins, sans-serif',
      fontSize: 20,
      fontWeight: 700,
      color: '#F56600',
      marginBottom: 10,
    },
  },
  text: {
    '@media (max-width: 600px)': {
      fontSize: 12,
    },
  },
  tombol: {
    fontFamily: 'Nunito Sans, sans-serif',
    marginTop: 40,
    marginBottom: 48,
    borderRadius: 15,
    backgroundColor: '#F56600',
    padding: '12px 24px',
    width: '100%',
    maxWidth: 300,

    '&:hover': {
      transition: '0.5s',
      backgroundColor: '#F56600',
      boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
      color: 'white',
    },

    '@media (max-width: 600px)': {
      padding: '12px 24px 12px 24px',
    },
  },
  pembungkusCarouselVideo: {
    '@media (max-width: 600px)': {
      display: 'none',
    },
  },
  articleDekstop: {
    '@media (max-width: 600px)': {
      display: 'none',
    },
    '@media (min-width: 600px)': {
      display: 'none',
    },
    '@media (min-width: 768px)': {
      display: 'block',
    },
  },
  articleMobile: {
    '@media (min-width: 768px)': {
      display: 'none',
    },
  },
}));

const descriptionArticle = [
  {
    articles:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In semper ex vel tellus vestibulum, sit amet cursus magna ultrices. In scelerisque dolor et erat hendrerit, at porta massa aliquam. Sed viverra massa sapien, eu accumsan diam ornare ultricies. Pellentesque et nibh eget est rutrum tincidunt a eget mauris. Aenean elit nisl, fermentum eu consectetur vel, sollicitudin sodales sapien. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Maecenas vulputate leo nec justo tristique, non ullamcorper ex porttitor. Etiam tristique magna vitae dapibus auctor. Nullam id leo non metus efficitur imperdiet. Nulla eu venenatis felis, eu facilisis risus. Integer vehicula lacinia felis, eu dignissim leo bibendum in. Nulla magna dui, consequat ac diam ut, vulputate vulputate sem. Integer vitae orci suscipit, imperdiet lorem vel, dictum odio. Nam ultricies molestie quam nec luctus.Lorem ipsum dolor sit amet, consectetur adipiscing elit. In semper ex vel tellus vestibulum, sit amet cursus magna ultrices. In scelerisque dolor et erat hendrerit, at porta massa aliquam. Sed viverra massa sapien, eu accumsan diam ornare ultricies. Pellentesque et nibh eget est rutrum tincidunt a eget mauris. Aenean elit nisl, fermentum eu consectetur vel, sollicitudin sodales sapien. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Maecenas vulputate leo nec justo tristique, non ullamcorper ex porttitor. Etiam tristique magna vitae dapibus auctor. Nullam id leo non metus efficitur imperdiet. Nulla eu venenatis felis, eu facilisis risus. Integer vehicula lacinia felis, eu dignissim leo bibendum in. Nulla magna dui, consequat ac diam ut, vulputate vulputate sem. Integer vitae orci suscipit, imperdiet lorem vel, dictum odio. Nam ultricies molestie quam nec luctus.',
  },
];

const ArticleDetail = (props) => {
  // const [video, setVideo] = useState(initialState);
  // const [article, setArticle] = useState(articleState);
  const [detailarticle, setDetailArticle] = useState();
  const [descriptionarticle, setDescArticle] = useState(descriptionArticle);
  const videos = useSelector(videosStore);
  const articles = useSelector(articlesStore);
  const navigate = useNavigate();

  const [fetching, setFetching] = useState(false);

  const { classes } = useStyle();

  const [searchParams, setSearchParams] = useSearchParams();

  async function fetchDetailMedia(id) {
    if (!id || id === '') {
      return navigate('/error');
    }
    fetch(`${process.env.REACT_APP_URL}/content/${id}`)
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        const element = res.data;

        console.log(element);
        setDetailArticle(element);
      });
  }

  useEffect(() => {
    const id = searchParams.get('id');

    if (!fetching) {
      (async function fetch() {
        await fetchDetailMedia(id);
      })().then((value) => setFetching(true));
    }
  }, [searchParams, fetching, fetchDetailMedia]);

  return (
    detailarticle && (
      <motion.div
        initial={{ width: 0 }}
        animate={{ width: '100%' }}
        exit={{ x: window.innerWidth, transition: { duration: 0.3 } }}
      >
        <div className="container mb-5">
          <Image
            src={
              detailarticle.name?.includes('.mp4')
                ? detailarticle.thumbnail_url
                : detailarticle.cover_url
            }
            mt={30}
            height={627}
            radius={30}
            className={classes.image}
          />
          <TitleComponent
            key={detailarticle.id}
            titleArticle={detailarticle.title}
            adminWritter={`Admin ${detailarticle.creator?.name}`}
            date={Date(detailarticle.created_at).substring(3, 15)}
          />
          <div className="row mt-5">
            <div className="col-lg-9">
              <Container>
              {detailarticle.description.map((item, key) => {
                if(item['type'] === 'text'){
                return (
                  <DescriptionAdminComponent
                    key={key}
                    articles={item['content']}
                  />
                );
                } else if(item['type'] === 'image'){
                return (
                  <Image src={item['content']} />
                );
                } else if(item['type'] === 'video'){
                return (
                  <ReactPlayer url={item['content']} />
                );
                } else if(item['type'] === 'link'){
                return (
                  <Center>
                  <Button className={classes.tombol} component="a" href={item['content']}>
                   {item.name}
                  </Button>
                </Center>
                );
                } else {
                  return (<></>)
                }
              })}
              </Container>
            </div>
            <div className="col">
              <InfoCardCompo />
            </div>

            {videos?.length > 0 && (
              <>
                <h1 className={classes.textDetail3}>Video Lainnya</h1>
                <div className={classes.pembungkusCarouselVideo}>
                  <Carousel
                    withControls={false}
                    slideSize={350}
                    slideGap={30}
                    align="start"
                  >
                    {videos.map((item, key) => {
                      return (
                        <Carousel.Slide>
                          <VideoCompo
                            key={key}
                            video={item.cover_url}
                            title={item.title}
                            desc={item.caption}
                            likes={item.likes}
                          />
                        </Carousel.Slide>
                      );
                    })}
                  </Carousel>
                </div>
              </>
            )}
            {articles?.length > 0 && (
              <>
                <h1 className={classes.textDetail4}>Artikel Lainnya</h1>
                <div className={classes.articleDekstop}>
                  <Carousel
                    withControls={true}
                    controlSize={40}
                    slideSize={350}
                    slideGap={30}
                    align="start"
                    styles={{
                      control: {
                        '&[data-inactive]': {
                          opacity: 0,
                          cursor: 'default',
                        },
                      },
                    }}
                  >
                    {articles?.map((item, key) => {
                      return (
                        <Carousel.Slide>
                          <CardArticleCompo
                            key={key}
                            image={item.cover_url}
                            title={item.title}
                            article={item.caption}
                            likes={item.likes}
                          />
                        </Carousel.Slide>
                      );
                    })}
                  </Carousel>
                </div>
              </>
            )}
            <div className={classes.articleMobile}>
              <ArticleMobileCompo />
            </div>
          </div>
        </div>
        <JumboTron2 />
        <FooterCompo />
      </motion.div>
    )
  );
};
export default ArticleDetail;
